import type { MinorStats } from "./types.ts";
import { minorLine } from "./minorStats.ts";

// The minor line is independent of MLB stats, even for a player already called up.
export const minorPopoverStats = (stats: MinorStats | undefined, season: number) => {
	const label = `Minor League · ${season}`;
	if (!stats || stats.season !== season || (stats.pa <= 0 && stats.outs <= 0)) {
		return { label, keyStats: "No minor league stats recorded for this season." };
	}
	const line = minorLine(stats);
	const rate = (n: number) => n.toFixed(3).replace(/^0/, "");
	const lines: string[] = [];
	if (stats.pa > 0) {
		const obp = (stats.h + stats.bb) / stats.pa;
		const slg = stats.ab > 0 ? (stats.h + stats.d + 2 * stats.t + 3 * stats.hr) / stats.ab : 0;
		lines.push(`Batting: ${stats.g} G · ${stats.pa} PA · ${stats.h}/${stats.ab} H/AB · ${stats.hr} HR · ${stats.rbi} RBI · AVG/OBP/SLG ${rate(line.avg)}/${rate(obp)}/${rate(slg)} · OPS ${rate(line.ops)}`);
	}
	if (stats.outs > 0) {
		lines.push(`Pitching: ${stats.gp} G · ${stats.gs} GS · ${line.ip.toFixed(1)} IP · ${stats.soP} K · ${stats.bbA} BB · ERA ${line.era.toFixed(2)} · WHIP ${line.whip.toFixed(2)}`);
	}
	return { label, keyStats: lines.join("\n") };
};
